import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik } from "formik"; import Menubar from "../Menubar"; import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";import Select from 'react-select'; import { Container, Row, Col, Nav, Button } from 'react-bootstrap'; import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable"; import { commonSelectProps, datetime, exportToExcel, formatNumberIndianWithDecimal, generatePdf } from "../utils/commonFunctions"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert";
import KpiService from "../../Services/KpiService";
import MasterService from "../../Services/MasterService";
export default function SecLevelTargetReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();const [yearList,setYearList] = useState([]);
  const [searchText, setSearch] = useState(""); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false); const [Deptlist, setDeptlist] = useState([]);
  let deptId = localStorage.getItem("sec_dept_id"); let SectariatName = localStorage.getItem("SectariatName"); const [Deptname, setDeptname] = useState()

  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("catid");
  const formik = useFormik({
    initialValues: { userId: "", district_id: "", mandal_id: "", department_id: "", periodic_id: "", year: "", date: "", Indicators: [{ indicator_id: "", entry_value: "" }], remarks: "" },
  })

  const [currentdate, setcurrentdate] = useState(''); const [currenttime, setcurrenttime] = useState(''); useEffect(() => { datetime(setcurrentdate, setcurrenttime); }, []);



  useEffect(() => {
    MasterService.getfinyears().then((achievvalueres) => {
                 if (achievvalueres.data) {
                   let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
                   setYearList(achievvalueres.data);
                 }
               });
    let params = { userId: username }
    KpiService.applicableSecMasterTargetsHods(params).then((res) => {
      if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); }
    });
    if(["114","115"].includes(roleid)){
    formik.setFieldValue("department_id", deptId);}
    // if (roleid !== "116") {
    //   store.dispatch({ type: "SHOW_SPINNER" }); const paramss = { "userId": username, "deptId": deptId }
    //   KpiService.getSecTargetreport(paramss).then((res) => {
    //     store.dispatch({ type: "HIDE_SPINNER" });
    //     if (res.data.SCODE === "02") { showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); }
    //     else {
    //       if (res.data.SCODE === "01") {


    //         setEntrydataEnb(true);
    //         setEntrydata(res.data.SDESC);

    //         let dept = res.data.SDESC[0].dept_name;
    //         setDeptname(dept);

    //         const uniqueDepartments = [...new Set(res.data.SDESC?.map((item) => item.dept_name)),]; setuniqueDepartments(uniqueDepartments);
    //         const uniqueMandals = [...new Set(res.data.SDESC?.map((item) => item.mandal_name))]; setuniqueMandals(uniqueMandals);
    //         console.log(uniqueMandals, "uniqueMandals")
    //       }

    //     }
    //   }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
    // }
  }, []);
  const getEntrydata = (idd) => { const params = { "userId": username, "deptId": formik.values.department_id,year:idd}; fetchEntryData(params); };
  const [uniqueDepartments, setuniqueDepartments] = useState(); const [uniqueMandals, setuniqueMandals] = useState();

  const fetchEntryData = (paramss) => {
      store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.getSecTargetreport(paramss).then((res) => {
      if (res.data.SCODE === "02") { showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); }
      else {
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true); setEntrydata(res.data.SDESC);
          let dept = res.data.SDESC[0].dept_name; setDeptname(dept);
          const uniqueDepartments = [...new Set(res.data.SDESC?.map((item) => item.dept_name)),];
          setuniqueDepartments(uniqueDepartments);

          const uniqueMandals = [...new Set(res.data.SDESC?.map((item) => item.mandal_name))];
          setuniqueMandals(uniqueMandals);

        }
        else { showAlertMessage(res.data.SDESC, "warning"); setEntrydata([]); setEntrydataEnb(false); }
      }
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };
  const filteredData =
    searchText.length > 0 && EntryData?.length
      ? EntryData.filter((item) => {
        return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase())); }));
      })
      : EntryData;


  return (
    <>
      <Menubar />
      <Container fluid className='map-header1'  > <div className='sa-title'> <h2>Secretariat <span> Targets</span></h2> </div> </Container>

      <Container fluid style={{ width: "87%" }} className="outer-page-content-container mt-3">
        {/* <Container fluid className='mt-3'> */}
        <FormikProvider value={formik} >
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4'>
              <Row>

               
                  <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}  >
                    <label className="mb-1 fw-bold"> Secretariat Name</label>
                      {(roleid !== "116") ?
                                    
                                        <Field type="text" name="department_id" value={SectariatName} className="mb-3 form-control" disabled={true}
                                          style={{ fontWeight: "bold" }}
                                        />:
  <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: roleid ==="115",
                       extraOnChange: (option) => {
                         formik.setFieldValue("year", "");setEntrydata([]);
                         } })} />}
                    </Col>

  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                                                                     <label className="mb-1 fw-bold">Year </label> <span style={{ color: "red" }}> *</span>
                                                                                                    <Select
                                                  {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year,
                                                   optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => {
                                                    getEntrydata(option? option.id:"");
                                                   } })}
                                                />   
                                                                                                   </Col>
                

              </Row>
            </div>
            <br />


            {entrydataEnb && <>

              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
                  <div style={{ display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px", }} onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }} onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }} >
                    <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} /> <input type="text" placeholder="Search " value={searchText} onChange={(event) => setSearch(event.target.value)} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
                  </div>
                </Col>

                <Col className=" mb-2 " >

                  <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "SecretariatlevlTargetReport",4)} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                  <button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "SecretariatlevlTargetReport")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </button>


                </Col>
              </Row>

              <div style={{ textAlign: "center", backgroundColor: "#d4e3d8", }} className="rounded-1 border py-1" >


                <span className="style"> {" "}Secretariat Level Targets Report Of Year {formik.values.year}</span>
                <br />


                <><span className="style-1"> Secretariat Name:</span>  <span className="style-2">{formik.values.department_id === "0" ? "ALL" : Deptname}</span>
                  <div className="text-end style-1">Report On : {currentdate} {currenttime}</div>
                </>
              </div>
              <div id="table-scroll" className="table-scroll">
                <div className="table-wrap">


                  <table className="table table-bordered custom-table table-responsive sticky-table" id="my-table">
                    <thead>
                      {entrydataEnb && <>
                        <tr className="text-center only-export"> <th colSpan={4}>
                          {" "}Secretariat Level Targets Report Of Year {formik.values.year}

                        </th>  </tr>
                        <tr className="text-center only-export"> <th colSpan={4}>{" "}Secretariat Name: {formik.values.department_id === "0" ? "ALL" : Deptname}</th>  </tr>
                        <tr className="only-export"><th colSpan={4}><div className="text-end style-1">Report On : {currentdate} {currenttime}</div></th></tr>
                      </>}
                      <tr className="text-center">
                        <th rowSpan={1} className="sticky-col sticky-sno">Sl.No.</th>   {formik.values.department_id === "0" && <th className="indicator-c">Secretariat Name</th>}
                        <th rowSpan={1} className="indicator-indicator-column">Indicator</th> <th rowSpan={1} className="unit-column">Unit</th> <th rowSpan={1} >TargetValue</th>

                      </tr>

                    </thead>

                    <tbody>
                      {
                        [...new Set(filteredData.map(item => item.indicator_id))].map((indicatorId, i) => {
                          const indicatorRows = filteredData.filter(item => item.indicator_id === indicatorId);
                          const indicatorName = indicatorRows[0]?.indicator_name; const Targets = indicatorRows[0]?.unit_cat_id === 1 ? formatNumberIndianWithDecimal(indicatorRows[0]?.targets_2025) : indicatorRows[0]?.targets_2025; const unitName = indicatorRows[0]?.unit_name;
                          return (
                            <tr key={indicatorId}>
                              <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}>{i + 1}</td>      {formik.values.department_id === "0" && <td className="indicator-column"> {indicatorRows[0]?.dept_name} </td>}

                              <td  style={{ textAlign: "left" }} className="indicator-column">{indicatorName}</td>
                              <td className="unit-column" style={{ textAlign: "left" }}>{unitName}</td>
                              <td style={{ textAlign: "right" }}>{Targets !== null && Targets !== undefined ? Targets : ""}</td>

                            </tr>
                          );
                        })
                      }
                    </tbody>






                  </table>

                </div>
              </div>
            </>
            }

          </Form>
        </FormikProvider>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}





